<template>
  <div class="ct-flex-row">
    <div class='choices flex-14'>
      <span class="wrap">
      <label class="has-tooltip" v-tooltip="{ content : getTooltipMessage('config_ilot') }"><span>Sélection/configuration des îlots</span></label>
      </span>
      <div v-for='ilot in ilots' :key='ilot.id_ilot' class='flex choice'
           :class="idIlot === ilot.id_ilot ? 'selected' : ''">
        <router-link v-if="selected.includes(ilot.id_ilot)"
                     :to='{ name : "simulation_ilot", params : {idExploitation, idSimulation, idIlot : ilot.id_ilot}}'
                     class='item-flex-full'>{{ ilot.nom }}
        </router-link>
        <span v-else class='item-flex-full'>{{ ilot.nom }}</span>
        <input :value='ilot.id_ilot' v-model='checkedNames' type='checkbox' @change='onCheckboxChanged(ilot.id_ilot)' :disabled="$can.not('edit-exploitation')">
      </div>
    </div>
    <router-view class="item-flex-full"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixinTooltip from '@/mixins/tooltip'
import mixinCheckResultat from '@/mixins/checkresultat'
import { removeIlotData } from '@/api/client-api'
import { SET_HAS_RESULTAT, SET_SIMULATION_PARCELLES } from '@/store/mutation-types'

export default {
  name: 'SimulationChoix',
  mixins: [mixinTooltip, mixinCheckResultat],

  props: {
    idExploitation: {
      type: String
    },
    idSimulation: {
      type: String
    },
    selected: {
      type: Array,
      default: () => []
    },
    idIlot: {
      type: String
    }
  },

  data () {
    return {
      checkedNames: this.selected
    }
  },

  computed: {
    ...mapState({ ilots: state => state.exploitation.ilots })
  },

  created () {
    if (!this.idIlot && this.selected.length > 0) {
      this.$router.push({
        name: 'simulation_ilot',
        params: {
          idExploitation: this.idExploitation,
          idSimulation: this.idSimulation,
          idIlot: this.selected[0]
        }
      })
    }
  },

  methods: {
    ...mapActions('confirm', ['confirm']),
    onCheckboxChanged (idIlot) {
      if (this.checkedNames.includes(idIlot)) {
        this.$emit('choice', this.checkedNames, idIlot)
      } else {
        this.confirmresult()
          .then(confirmation => {
            if (!confirmation) {
              this.checkedNames.push(idIlot)
              this.$emit('choice', this.checkedNames, idIlot)
            } else {
              removeIlotData(this.idExploitation, this.idSimulation, idIlot)
                .then(res => {
                  let index = this.checkedNames.indexOf(res)
                  if (index !== -1) {
                    this.checkedNames.splice(index, 1)
                  }
                  this.$store.commit(SET_SIMULATION_PARCELLES, res.parcelles)
                  this.$store.commit(SET_HAS_RESULTAT, res.has_resultat)
                  this.$emit('choice', this.checkedNames)
                })
            }
          })
      }
    }
  }
}
</script>
